import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import React, { useEffect, useState } from "react";
import CardExibirPdf from "../../../components/CardExibirPDF";
import CardSeplag from "../../../components/CardSeplag";
import download from "downloadjs";
import { listarPerfilSitemaLogado } from "../../../service/seguranca/usuario";
import "./style.css";
import { MultiSelect } from "primereact/multiselect";
import {
    buscaCiclo,
    buscaProduto,
    buscarAcao,
    buscarExercicio,
    buscarOrgaos,
    buscarSubAcao,
    carregarArvoreMonitoraComFiltro
  } from "../../../service/ArvoreMonitora/indexFiltro";
import { gerarRelatorioIndicadoresAcao } from "../../../service/ArvoreMonitora";



const RelatorioIndicadoresAcao = () => {

      const TipoRelatorio = [
        { name: "PDF", code: "P" },
    
        { name: "EXCEL", code: "E" },
      ];

      const [cDadosArvore, setCDadosArvore] = useState([]);
      const [cDadosExercicios, setCDadosExercicios] = useState([]);
      const [cDadosCiclo, setCDadosCiclo] = useState([]);
      const [cDadosOrgaos, setCDadosOrgaos] = useState([]);
      const [cDadosUOs, setCDadosUOs] = useState([]);
      const [cDadosProgramas, setCDadosProgramas] = useState([]);
      const [cDadosAcoes, setCDadosAcoes] = useState([]);
    
    
      const [exercicioSelecionado, setExercicioSelecionado] = useState(null);
      const [cicloSelecionado, setCicloSelecionado] = useState(null);
    
      const [orgaoSelecionado, setOrgaoSelecionado] = useState([]);
      const [idenOrgaoSelecionado, setIdenOrgaoSelecionado] = useState(null);
    
      const [uoSelecionada, setUoSelecionada] = useState(null);
      const [idenUoSelecionada, setIdenUoSelecionada] = useState(null);
    
      const [programaSelecionado, setProgramaSelecionado] = useState(null);
      const [idenProgramaSelecionado, setIdenProgramaSelecionado] = useState(null);
    
      const [acaoSelecionada, setAcaoSelecionada] = useState(null);
      const [idenAcaoSelecionada, setIdenAcaoSelecionada] = useState(null);
      

      const [itemPrioritarioSelecionado, setItemPrioritarioSelecionado] = useState({
        name: "TODOS",
        code: null,
      });
      const [tipoRelatorioSelecionado, setTipoRelatorioSelecionado] = useState({ name: "PDF", code: "P" });
    
      const [tituloPDF, setTituloPDF] = useState("");
      const [dadosRelatorioBase64, setDadosRelatorioBase64] = useState(null);
      const [isExibirPDF, setIsExibirPDF] = useState(false);


      useEffect(() => {
        setCDadosExercicios([]);
        buscarExercicio().then((res) => {
          setCDadosExercicios(res.data.listaExercicios);
        });
      }, []);


      let defaultArvoreMonitora = {
        arvorePtaMonitoras: cDadosArvore,
        listaExercicios: cDadosExercicios,
        parametroExercicio: cDadosCiclo,
        orgaoFiplans: cDadosOrgaos,
        unidadeOrcamentarias: cDadosUOs,
        programas: cDadosProgramas,
        acao: cDadosAcoes,
        ciclo: cDadosCiclo,
      };

      const onChangeExercicio = (e) => {
        setExercicioSelecionado(e.value);
        setOrgaoSelecionado([]);
        setCDadosUOs([]);
        setUoSelecionada(null);
        setCDadosProgramas([]);
        setProgramaSelecionado(null);
        setCDadosAcoes([]);
        setAcaoSelecionada(null);
    
        buscaCiclo(e.value.idenExercicio).then((retorno) => {
          setCDadosCiclo(retorno.data);
          buscarOrgaos(e.value.idenExercicio).then((res) => {
            setCDadosOrgaos(res.data);
          });
        });
      };

      const onChangeOrgao = (e) => {
        setOrgaoSelecionado(e.value);
        setUoSelecionada(null);
        setProgramaSelecionado(null);
        setCDadosUOs(null);
        setCDadosProgramas(null);
        setCDadosArvore(null);
        let filtro = {
          idenExercicio: exercicioSelecionado.idenExercicio,
          idenOrgao: e.value,
          idenUo: null,
          idenPrograma: null,
        };
        carregarArvoreMonitoraComFiltro(filtro, defaultArvoreMonitora).then((res) => {
          setCDadosCiclo(res.parametroExercicio);
          setCDadosOrgaos(res.orgaoFiplans);
          setCDadosUOs(res.unidadeOrcamentarias);
        });
      };

      const onChangeUo = (e) => {
        setUoSelecionada(e.value);
        setProgramaSelecionado(null);
        setCDadosProgramas(null);
        setCDadosArvore(null);
        let filtro = {
          idenExercicio: exercicioSelecionado.idenExercicio,
          idenOrgao: idenOrgaoSelecionado,
          idenUo: e.value,
          idenPrograma: null,
        };
        carregarArvoreMonitoraComFiltro(filtro, defaultArvoreMonitora).then((res) => {
          setCDadosCiclo(res.parametroExercicio);
          setCDadosOrgaos(res.orgaoFiplans);
          setCDadosUOs(res.unidadeOrcamentarias);
          setCDadosProgramas(res.programas);
        });
      };

      const onChangePrograma = (e) => {
        setProgramaSelecionado(e.value);
        let listaPrograma = [e.value];
        let listaUnidOrcamentaria = [uoSelecionada];
        let JsonBody = {
          listaPrograma,
          listaUnidOrcamentaria,
        };
        buscarAcao(JsonBody).then((res) => {
          setCDadosAcoes(res);
          setAcaoSelecionada(null);
        });
      };

      const onChangeAcao = (e) => {
        setAcaoSelecionada(e.value);
        let idenPtaMonitora = e.value.map((e) => e.key );
      };
    
     
      const onChangeTipoRelatorio = (e) => {
        setTipoRelatorioSelecionado(e.value);
      };

      const gerarRelatorio = () => {
        let idenExercicio =
          exercicioSelecionado && exercicioSelecionado != null ? exercicioSelecionado.idenExercicio : null;
        let idenCiclo = cicloSelecionado && cicloSelecionado != null ? cicloSelecionado.idenCiclo : null;
        let listaIdenOrgao = orgaoSelecionado && orgaoSelecionado != null ? idenOrgaoSelecionado : [];
        let listaUo = uoSelecionada && uoSelecionada != null ? idenUoSelecionada : [];
        let listaPrograma = programaSelecionado && programaSelecionado != null ? idenProgramaSelecionado : [];
        let listaAcao = acaoSelecionada && acaoSelecionada != null ? idenAcaoSelecionada : [];
        let tipoRelatorio = tipoRelatorioSelecionado && tipoRelatorioSelecionado != null ? tipoRelatorioSelecionado.code : null;
    
        if(!idenExercicio || !idenCiclo){
    
          window.$toast.current.show({ severity: "error", summary: `${!idenExercicio ? 'Exercício' : 'Ciclo'} não pode ser nulo.` });
        }else{
          let JsonBody = {
            idenExercicio,
            idenCiclo,
            listaIdenOrgao,
            listaUo,
            listaPrograma,
            listaAcao,
            tipoRelatorio
          };
    
          gerarRelatorioIndicadoresAcao(JsonBody).then((res) => {
            if (tipoRelatorio === "E") {
              download(
                `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.data.dadosRelatorioBase64}`,
                `${res.data.nomeArquivo}`,
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              );
            } else {
              let valorMb = res.data.dadosRelatorioBase64.length / 1024000;
              if (valorMb > 2) {
                download(
                  `data:application/pdf;base64,${res.data.dadosRelatorioBase64}`,
                  `${res.data.nomeArquivo}`,
                  "application/pdf"
                );
              } else {
                setTituloPDF(res.data.nomeArquivo);
                setDadosRelatorioBase64(res.data.dadosRelatorioBase64);
                setIsExibirPDF(true);
              }
            }
          });}
      };
    
      function fecharJanela() {
        setIsExibirPDF(false);
      }
    
      useEffect (() => {
        if(orgaoSelecionado === null){
          setOrgaoSelecionado([])
        }else{
          setIdenOrgaoSelecionado(orgaoSelecionado.map((os) => os.idenOrgao));
        }
    
      },[orgaoSelecionado]);
    
      useEffect (() => {
        if(uoSelecionada === null){
          setUoSelecionada([])
        }else{
          setIdenUoSelecionada(uoSelecionada.map((uos) => uos.idenUo));
        }
    
      },[uoSelecionada]);
    
      useEffect (() => {
        if(programaSelecionado === null){
          setProgramaSelecionado([])
        }else{
          setIdenProgramaSelecionado(programaSelecionado.map((os) => os.idenPrograma));
        }
    
      },[programaSelecionado]);
    
      useEffect (() => {
        if(acaoSelecionada === null){
          setAcaoSelecionada([])
        }else{
          setIdenAcaoSelecionada(acaoSelecionada.map((as) => as.idenPtaFiplan));
        }
    
      },[acaoSelecionada]);
    
      return (
        <CardSeplag title="MONITORAMENTO : RELATÓRIO DE INDICADORES DE AÇÃO">
          <div className="p-fluid grid line-height-4">
            <div className="field col-12 md:col-12 ">
              <div className="p-fluid grid line-height-4">
                <div className="field col-12 md:col-4 ">
                  <span>
                    <label htmlFor="selExercicio">Exercício</label>
                    <Dropdown
                      emptyMessage="Dados não encontrados"
                      emptyFilterMessage="Opção não encontrada"
                      id="selExercicio"
                      value={exercicioSelecionado}
                      options={cDadosExercicios}
                      onChange={onChangeExercicio}
                      optionLabel="ano"
                      filter
                      showClear
                      filterBy="ano"
                      placeholder="Selecione um exercício"
                      required={true}
                    />
                  </span>
                </div>
                <div className="field col-12 md:col-4">
                  <span>
                    <label htmlFor="selCiclo">Ciclo</label>
                    <Dropdown
                      emptyMessage="Dados não encontrados"
                      emptyFilterMessage="Opção não encontrada"
                      id="selCiclo"
                      value={cicloSelecionado}
                      options={cDadosCiclo}
                      onChange={(e) => {
                        setCicloSelecionado(e.value);
                      }}
                      optionLabel="descCiclo"
                      filter
                      showClear
                      filterBy="descricaoFiplan"
                      placeholder="Selecione um Ciclo"
                      required={true}
                    />
                  </span>
                </div>
                <div className="field col-12 md:col-4">
                  <span>
                    <label htmlFor="selOrgao">Órgão</label>
                    <MultiSelect 
                      emptyFilterMessage="Opção não encontrada"
                      id="selOrgao"
                      value={orgaoSelecionado} 
                      options={cDadosOrgaos} 
                      onChange={(e) => onChangeOrgao(e)} 
                      optionLabel="descricaoFiplan" 
                      filter
                      filterBy="descricaoFiplan"
                      placeholder="Selecione um Órgão" 
                      />
                  </span>
                </div>
              </div>
              <div className="p-fluid grid line-height-4">
                <div className="field col-12 md:col-4 ">
                  <span>
                    <label htmlFor="selUO">U.O.</label>
                    <MultiSelect 
                      emptyFilterMessage="Opção não encontrada"
                      id="selUO"
                      value={uoSelecionada} 
                      options={cDadosUOs} 
                      onChange={(e) => onChangeUo(e)} 
                      optionLabel="descricaoFiplan" 
                      filter
                      filterBy="descricaoFiplan"
                      placeholder="Selecione uma U.O." 
                    />
                  </span>
                </div>
                <div className="field col-12 md:col-4">
                  <span>
                    <label htmlFor="selPrograma">Programa</label>
                    <MultiSelect 
                      emptyFilterMessage="Opção não encontrada"
                      id="selPrograma"
                      value={programaSelecionado} 
                      options={cDadosProgramas} 
                      onChange={onChangePrograma} 
                      optionLabel="descricaoFiplan" 
                      filter
                      filterBy="descricaoFiplan"
                      placeholder="Selecione uma Programa" 
                    />
                  </span>
                </div>
                <div className="field col-12 md:col-4">
                  <span>
                    <label htmlFor="selAcao">Ação</label>
                    <MultiSelect 
                      emptyFilterMessage="Opção não encontrada"
                      id="selAcao"
                      value={acaoSelecionada} 
                      options={cDadosAcoes} 
                      onChange={onChangeAcao} 
                      optionLabel="descFiplan" 
                      filter
                      filterBy="descFiplan"
                      placeholder="Selecione uma Ação" 
                    />
                  </span>
                </div>
              </div>
              <div className="p-fluid grid line-height-4">
                <div className="field col-12 md:col-4">
                  <span>
                    <label htmlFor="selTipo">Tipo de Impressão do Relatório</label>
                    <Dropdown
                      emptyMessage="Dados não encontrados"
                      emptyFilterMessage="Opção não encontrada"
                      id="selTipo"
                      value={tipoRelatorioSelecionado}
                      options={TipoRelatorio}
                      onChange={onChangeTipoRelatorio}
                      optionLabel="name"
                      filter
                      showClear
                      filterBy="true"
                      placeholder="Selecione um Tipo de Impressão de Relatório"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 md:col-1">
            <Button type="button" label="Gerar" icon="pi pi-file" className="col-3 col-12" onClick={gerarRelatorio} />
    
            {isExibirPDF && (
              <CardExibirPdf
                tamanhoTela="50.vw"
                alturaTela="360.vh"
                stringPDF={"data:application/pdf;base64," + dadosRelatorioBase64}
                tituloTela={tituloPDF}
                isExibirPDF={isExibirPDF}
                position="center"
                onHide={fecharJanela}
              />
            )}
          </div>
        </CardSeplag>
      );
}
export default RelatorioIndicadoresAcao;